<script>
export default {
  template: '<div></div>',
};
</script>

<style>
@import '~vue-form-generator/dist/vfg.css';
@import '~messenger-hubspot/build/css/messenger.css';
@import '~messenger-hubspot/build/css/messenger-theme-future.css';
</style>
